<template>
  <el-card v-loading="loading">
    <template slot="header">
      编辑用户信息
    </template>
    <el-form :model="UserDetail"
             :rules="rules"
             ref="ude"
             label-position="right"
             label-width="130px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="UserDetail.name"></el-input>
      </el-form-item>
      <el-form-item label="头像" prop="img">
        <img-upload :return-url="true" :default-url="UserDetail.img_url" v-model="UserDetail.img" @change="setImg"></img-upload>
      </el-form-item>
      <el-form-item label="生日" prop="birthday">
        <el-date-picker
          v-model="UserDetail.birthday"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择生日时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="入校时间" prop="school_start">
        <el-date-picker
          v-model="UserDetail.school_start"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择生日时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="毕业时间" prop="school_end">
        <el-date-picker
          v-model="UserDetail.school_end"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择生日时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="学校名称" prop="schoole_name">
        <el-input v-model="UserDetail.schoole_name"></el-input>
      </el-form-item>
      <el-form-item label="专业名称" prop="magor">
        <el-input v-model="UserDetail.magor"></el-input>
      </el-form-item>
      <el-form-item label="学历类别" prop="magor_type">
        <el-input v-model="UserDetail.magor_type"></el-input>
      </el-form-item>

      <el-form-item label="学习形式" prop="study_func">
        <el-input v-model="UserDetail.study_func"></el-input>
      </el-form-item>
      <el-form-item label="层次" prop="gradation">
        <el-input v-model="UserDetail.gradation"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-input v-model="UserDetail.status"></el-input>
      </el-form-item>
      <el-form-item label="校（院）长姓名" prop="dean_name">
        <el-input v-model="UserDetail.dean_name"></el-input>
      </el-form-item>
      <el-form-item label="证书编号" prop="card_id">
        <el-input v-model="UserDetail.card_id"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="card_number">
        <el-input v-model="UserDetail.card_number"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="update">保存</el-button>
        <el-button type="success" @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import '@/static/test'
  import ImgUpload from "../img/ImgUpload";

  export default {
    name: "UserDetailEdit",
    props: {
      id: {
        required: true
      }
    },
    components: {ImgUpload},
    data() {
      return {
        user_detail: {}
      }
    },
    computed: {
      ...mapState({
        UserDetail: state => state.user_detail.UserDetail,
        rules: state => state.user_detail.rules,
        loading: state => state.user_detail.loading
      })
    },
    methods: {
      setImg(value){
        this.$store.commit('userDetail/setNewUserDetail', {...this.UserDetail, img: value});
      },
      back() {
        this.$router.back();
      },
      update() {
        let vthis = this;

        this.$refs['ude'].validate((validate) => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('user_detail/update').then(res => {
            vthis.$confirm('是否关闭页面?')
              .then(_ => {
                vthis.$router.back();
              });
          })
            .catch(res => {
              console.log(res);
            });
        });
      }
    },
    created() {
      this.$store.dispatch('user_detail/show', {id: this.id});
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/user_detail/UserDetailEdit.vue